import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials lets the browser attach the httpOnly `admin_token` cookie
// on every same-site request to the API. Frontend code never reads the JWT.
const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Legacy header-mode support: if a token is somehow still in localStorage
// (left over from before the cookie migration), include it as a fallback.
// Once all browsers have logged in once after the migration, this code path
// becomes dead. Safe to delete after one billing cycle.
api.interceptors.request.use((config) => {
    try {
        const legacy = localStorage.getItem("admin_token");
        if (legacy && !config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${legacy}`;
        }
    } catch {
        // localStorage may throw in private-browsing mode — ignore
    }
    return config;
});

export default api;
